import TripApprovalComponent from './trip-approval-component';
import TripApprovalService from './trip-approval-service';

const MODULE_NAME = 'app.trip.approval';
const module = angular.module(MODULE_NAME, [])
    .directive(TripApprovalComponent.DIRECTIVE_NAME, TripApprovalComponent)
    .service('tripApprovalService', TripApprovalService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-approval/trip-approval-module.js